import config from 'constants/config'

function getLoyaltyProgramDisplayName(): string {
  return config.loyalty.programDisplayName
}

export default getLoyaltyProgramDisplayName
